<template>
  <div class="group-buy-success-dialog">
    <header>
      <img src="../../../../assets/img/public/popup_close.png" alt="关闭" @click="close"/>
    </header>
    <div class="content">
      <div class="content-success">
        <img src="../../../../assets/img/productDetail/icon_success.png" alt="成功" class="success-icon"/>
        <span>
          <template v-if="groupBuyDetailVuex.status === 3">拼团成功</template>
          <template v-else-if="isUserInGroup.isCaptain">开团成功</template>
          <template v-else>参团成功</template>
        </span>
      </div>
      <template v-if="groupBuyDetailVuex.status === 3">
        <span class="content-text">恭喜你，拼团成功，快去查看课程吧～</span>
      </template>
      <template v-else>
        <span class="content-text">还差<span class="yellow-text">{{groupPersonNum()}}</span>人拼团成功，快邀请好友拼团吧～</span>
        <span class="content-text">拼团成功后开课</span>
      </template>

      <div class="share-icon" v-if="groupBuyDetailVuex.status !== 3">
        <div class="share-item" v-for="(item, index) in shareIconList" :key="index" @click="share(item.id)">
          <img :src="item.imgUrl" alt=""/>
          <span>{{item.title}}</span>
        </div>
      </div>
    </div>
    <GroupBuyQRCodeDialog :url="shareUrl" ref="groupBuyQRCodeDialog"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import GroupBuyQRCodeDialog from '@/pages/courseDetail/courseActivity/groupBuy/GroupBuyQRCodeDialog.vue';
import { copyTool } from '@/utils/tools';

export default {
  components: {
    GroupBuyQRCodeDialog,
  },
  computed: {
    ...mapState([
      'groupBuyDetailVuex',
      'courseBaseData',
      'userInfo',
    ]),
  },
  data() {
    return {
      shareIconList: [
        {
          id: 1,
          title: '微信好友',
          imgUrl: require('../../../../assets/img/productDetail/icon_wechat_share.png'),
        },
        {
          id: 2,
          title: 'QQ好友',
          imgUrl: require('../../../../assets/img/productDetail/icon_qq_share.png'),
        },
        {
          id: 3,
          title: '当面扫码',
          imgUrl: require('../../../../assets/img/productDetail/icon_qr_code.png'),
        },
        {
          id: 4,
          title: '复制链接',
          imgUrl: require('../../../../assets/img/productDetail/icon_url.png'),
        },
      ],
      shareUrl: '',
      isUserInGroup: {},
    };
  },
  mounted() {
    const { groupOrderRespVOS } = this.groupBuyDetailVuex;
    const user = {
      isCaptain: false,
      isParticipate: false,
    };
    groupOrderRespVOS.forEach((item) => {
      if (item.userId === this.userInfo?.id) {
        user.isParticipate = true;
        user.isCaptain = item.isCaptain === 1;
      }
    });
    this.isUserInGroup = user;
  },
  methods: {
    close() {
      this.$emit('closeDialog');
    },
    groupPersonNum() {
      const { groupNumber, joinNumber } = this.groupBuyDetailVuex;
      const num = groupNumber - joinNumber;
      return num > 0 ? num : '';
    },
    share(val) {
      this.shareUrl = `${window.location.origin}/ark${this.$route.path}?groupId=${this.groupBuyDetailVuex.groupId}`;
      const { isApp } = this.$root.$data;
      const { groupActivityDiscountVOS } = this.groupBuyDetailVuex;
      // eslint-disable-next-line
      const { groupPrice } = groupActivityDiscountVOS.filter((item) => item.productSkuId = this.groupBuyDetailVuex.productSkuId)[0];
      const title = `【仅剩${this.groupBuyDetailVuex.groupNumber - this.groupBuyDetailVuex.joinNumber}个名额】我用${groupPrice}元拼了${this.courseBaseData.name}`;
      const content = `我在启航教育参与拼团活动，还差${this.groupBuyDetailVuex.groupNumber - this.groupBuyDetailVuex.joinNumber}人拼团成功，快来参与吧~`;
      switch (val) {
        case 1:
          if (isApp) {
            const query = {
              url: this.shareUrl,
              title,
              type: 1,
              content,
              icon: '',
            };
            this.$sendToApp('share', query, false);
          } else {
            copyTool(this.shareUrl).then(() => {
              this.$toast('链接复制成功，正在打开微信...');
              setTimeout(() => {
                window.location.href = 'weixin://';
              }, 1000);
            }).catch(() => {
              this.$toast('复制失败');
            });
          }
          break;
        case 2:
          if (isApp) {
            const query = {
              url: this.shareUrl,
              title,
              type: 2,
              content,
              icon: '',
            };
            this.$sendToApp('share', query, false);
          } else {
            copyTool(this.shareUrl).then(() => {
              this.$toast('链接复制成功，正在打开QQ...');
              setTimeout(() => {
                window.location.href = 'tencent://';
              }, 1000);
            }).catch(() => {
              this.$toast('复制失败');
            });
          }
          break;
        case 3:
          this.$refs.groupBuyQRCodeDialog.show = true;
          break;
        case 4:
          copyTool(this.shareUrl).then(() => {
            this.$toast('链接复制成功，快分享给你的好友来参团吧');
          }).catch(() => {
            this.$toast('复制失败');
          });
          break;
        default:
          break;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.group-buy-success-dialog{
  width: 624px;
  padding: 36px;
  overflow: hidden;

  header{
    display: flex;
    justify-content: flex-end;
    text-align: right;

    img{
      width: 29px;
      height: 29px;
    }
  }

  .content{
    display: flex;
    flex-direction: column;
    align-items: center;

    .content-success{
      display: flex;
      flex-direction: column;
      align-items: center;

      .success-icon{
        width: 72px;
      }

      span{
        margin-top: 16px;
        margin-bottom: 7px;
        color: #333;
        font-weight: 600;
        font-size: 29px;
        line-height: 40px;
      }
    }

    .content-text{
      margin-top: 7px;
      color: #787878;
      font-weight: 400;
      font-size: 25px;
      line-height: 36px;

      .yellow-text{
        color: $theme_color;
      }
    }

    .share-icon{
      display: flex;
      justify-content: space-around;
      width: 100%;
      margin-top: 36px;

      .share-item{
        display: flex;
        flex-direction: column;
        align-items: center;

        img{
          width: 80px;
          margin-bottom: 14px;
        }

        span{
          margin-bottom: 18px;
          color: #787878;
          font-weight: 400;
          font-size: 25px;
          line-height: 36px;
        }
      }
    }
  }
}
</style>
